import React from "react";
import { useRecoilValue, useRecoilState } from "recoil";

import Button from "@mui/material/Button";
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';

import { gis2TokenAtom, isLoggedInSelector } from './loginAtoms.js'
import LoginModal, { tableToAuthAgainst, fieldToAuthAgainst } from './LoginModal.jsx'
import loginUtil from './login.js'

const LoginButton = () => {
	const [loginModalOpen, setLoginModalOpen] = React.useState(false);
  const [gis2Token, setGis2Token] = useRecoilState(gis2TokenAtom)
  const isLoggedIn = useRecoilValue(isLoggedInSelector)

  const openLoginModal = () => setLoginModalOpen(true)
  const closeLoginModal = () => setLoginModalOpen(false)

  const logout = (e) => {
    loginUtil.putGis2TokenIntoStorage(null)
    window.location.reload()
  }

  React.useEffect(() => {
    let thisCallHasExpired = false

    if (!gis2Token) {
      return
    }

    loginUtil.isGis2TokenStillValid(
      gis2Token,
      tableToAuthAgainst,
      fieldToAuthAgainst,
    )
    .then((isValid) => {
      if (thisCallHasExpired) {
        return
      }

      if (!isValid) {
        setGis2Token(null)
      }
    })
    .catch((e) => {
      if (!thisCallHasExpired) {
        console.error(e)
        setGis2Token(null)
      }
    })

    return () => {
      thisCallHasExpired = true
    }
  }, [gis2Token, setGis2Token])

	return (
		<>
	    <Button
	      variant="outlined"
	      startIcon={isLoggedIn ? <LogoutIcon /> : <LoginIcon />}
	      onClick={isLoggedIn ? logout : openLoginModal}
	      sx={{
	        width: "100%",
	        height: "100%",
	      }}>
	      {isLoggedIn ? "Logout" : "HSDS Login"}
	    </Button>
	    <LoginModal
	      isOpen={loginModalOpen}
	      close={closeLoginModal}
	      setToken={setGis2Token} />
		</>
	)
}

export default LoginButton;